import usePaddle from "@Composables/usePaddle";

import PADDLE_TRANSACTION_TYPE from "@Constants/paddle-transaction-type";

import { getPaymentMethodCheckoutSessionApi } from "@Resources/js/api/payment-method";

export default function usePaymentMethod() {
  const { openPaddleCompactCheckoutByTransaction } = usePaddle();

  async function updatePaymentMethod(subscription) {
    const checkoutSession = await getPaymentMethodCheckoutSessionApi(subscription);

    openPaddleCompactCheckoutByTransaction(
      PADDLE_TRANSACTION_TYPE.PAYMENT_METHOD_UPDATE,
      checkoutSession.data,
    );
  }

  return {
    updatePaymentMethod,
  };
}
